import { Breadcrumb, Spin } from 'antd';
import React, { useEffect } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';

import styles from './index.module.scss';
import { useCategoryGet } from '../../../hooks/api/category';
import ProductUpdate from './ProductUpdate';
import NoData from '../../Common/NoData';
import { useProductContext } from '../../../context/products';

export default function ProductsDetails(): React.ReactNode | null {
  const { id, name } = useParams();
  const navigate = useNavigate();
  const { data: productData } = useProductContext();
  const categoryGet = useCategoryGet({ autoStart: false });
  const currentProduct = productData?.find((p) => p.id === id);

  const { data, loading, error } = categoryGet;

  useEffect(() => {
    categoryGet.fetch({ productId: id });
  }, [id]);

  return (
    <div className="wrapper">
      {data && data.length > 0
        ? (
          <div className={styles.contentWrapper}>
            <div>
              <div className="breadcrumb">
                <Breadcrumb
                  items={[
                    {
                      title: <NavLink to="/" className="breadcrumbLink">Help portal</NavLink>,
                    },
                    {
                      title: `${name}`,
                    },
                  ]}
                />
              </div>
              <div className={styles.content}>
                <h2>{name}</h2>
                {data
                  ? (
                    <div className={styles.categoriesWrapper}>
                      {data.map((item) => (
                        <div
                          role="button"
                          tabIndex={-1}
                          key={item.id}
                          className={styles.card}
                          // eslint-disable-next-line max-len
                          onClick={() => navigate(`/category/${encodeURIComponent(name || '')}/${id}/${encodeURIComponent(item.name)}/${item.id}`)}

                        >
                          <h4>{item.name}</h4>
                          <span>
                            {item.articlesSize}
                            {' '}
                            articles
                          </span>
                        </div>
                      ))}
                    </div>
                  )
                  : null}
              </div>
            </div>
            <div className={styles.updateWrapper}>
              <ProductUpdate productId={id || ''} productName={name || ''} productLogo={currentProduct?.logo || ''} />
            </div>
          </div>
        )
        : (
          <div>
            <NoData />
          </div>
        )}
      {loading ? (
        <div className="spin">
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
